import { useQuery } from 'react-query';

import { GetSubsetInconsistenciesResponse } from '../../../../backend/src/matter/inconsistency/dto/get-subset-inconsistencies.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export interface InconsistencyFilters {
  types?: string[];
  levels?: string[];
  sources?: string[];
  includedDocIds?: string[];
  excludedDocIds?: string[];
  hasRelevantFacts?: boolean;
  isPleading?: boolean;
}

interface GetSubsetInconsistenciesProps {
  matterId: string;
  subsetId: string;
  searchQuery?: string;
  page?: number;
  pageSize?: number;
  filters: InconsistencyFilters;
}

export const useGetSubsetInconsistencies = ({
  matterId,
  subsetId,
  searchQuery,
  page,
  pageSize,
  filters,
}: GetSubsetInconsistenciesProps) => {
  const { getFetchConfig } = useGetFetchConfig();
  const fetchConfigPOST = getFetchConfig({
    method: FetchMethod.POST,
    data: {
      searchQuery: searchQuery || '',
      page: page || 1,
      pageSize: pageSize || 50,
      ...filters,
    },
  });

  return useQuery<GetSubsetInconsistenciesResponse>(
    [QueryEntity.SubsetInconsistencies, { subsetId, searchQuery, filters, page, pageSize }],
    async () => {
      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/inconsistencies`,
        fetchConfigPOST,
      );
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    },
    {
      enabled: !!matterId && !!subsetId,
      refetchOnWindowFocus: false,
    },
  );
};
